/**
	* @ngdoc function
	* @name app.controller:MFTestsCtrl
	* @description
	* # MFTestsCtrl
	* Controller of the app
	*/
angular.module('app')
	.controller('MFTestsCtrl', /* @ngInject */ $scope => {
		$scope.model1 = [
			{
				kid: 'K_NODE;PERSON',
				name: 'Personne',
			},
		];

		$scope.model2 = [
			{
				kid: 'K_NODE;PERS_OLIVIER',
				isa: 'K_NODE;PERSON',
				isa_name: 'Personne',
				name: 'Olivier BERAUD',
			},
		];

		$scope.model3 = [];
	});
